import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useCanCreateCanvasInCurrentLocation } from '~/hooks/canvases/useCanCreateCanvasInCurrentLocation';
import { useDraftCanvas } from '~/hooks/canvases/useDraftCanvas';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { CentralizedBoardSelectors } from '~/store/centralizedBoard/selectors';

export const useOpenBlankCanvasAnnouncementCommand = () => {
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const { canCreateCanvas } = useCanCreateCanvasInCurrentLocation();
  const { openDraftCanvas } = useDraftCanvas();
  const boardId = useSelector(CentralizedBoardSelectors.boardId);

  const canOpenBlankCanvas = generativeCanvasEnabled && canCreateCanvas;

  const openBlankCanvas = useCallback(
    (announcementId?: string) => {
      if (!canOpenBlankCanvas) {
        return;
      }

      openDraftCanvas({
        boardId: boardId ?? undefined,
        analyticsContext: {
          source: 'announcement',
          ...(boardId ? { board_id: boardId } : {}),
          ...(announcementId ? { announcement_id: announcementId } : {}),
        },
      });
    },
    [boardId, canOpenBlankCanvas, openDraftCanvas],
  );

  return { canOpenBlankCanvas, openBlankCanvas };
};
